import { render, staticRenderFns } from "./MealBreakCancelled.vue?vue&type=template&id=4ef0518f&"
import script from "./MealBreakCancelled.vue?vue&type=script&lang=js&"
export * from "./MealBreakCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports